module.exports = __webpack_public_path__ + "static/media/cw-logo.3e59cb97.png";